import { render } from "./OutletMenu.vue?vue&type=template&id=39c14df3&lang=pug"
import script from "./OutletMenu.vue?vue&type=script&lang=js"
export * from "./OutletMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__